import { render, staticRenderFns } from "./MiscellaneousFixtures.vue?vue&type=template&id=735c50f8&"
import script from "./MiscellaneousFixtures.vue?vue&type=script&lang=ts&"
export * from "./MiscellaneousFixtures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports